/* @flow */

import { em } from 'polished';
import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  tableContainer: {
    maxHeight: 625,
    overflowY: 'auto',
    position: 'relative',
  },
  table: {
    width: '100%',
    marginTop: 26,
    borderCollapse: 'collapse',
  },
  tableHeadCell: {
    position: 'sticky',
    top: 0,
    backgroundColor: ({ theme }: ThemeFunction) => theme.colorPrimary,
    borderBottom: ({ theme }: ThemeFunction) =>
      `1px solid ${theme.textColorTertiary}`,
    fontWeight: 700,
    fontSize: em(14),
    textAlign: 'left',
    minWidth: 83,
    padding: [15, 0],
    zIndex: 1,
  },
  tableTitle: {
    textAlign: 'left',
    margin: 0,
  },
  tableCell: {
    borderBottom: 'none !important',
    padding: [23, 0],
    textAlign: 'left',

    '&:nth-of-type(1)': {
      paddingRight: 20,
    },
  },
  tableCellCentered: {
    textAlign: 'center',
  },
  tableBody: {
    width: '100%',
    overflowY: 'auto',
  },
};
